import { getClientById } from './getClientById';

const noLogoClients = ['LATAMP-Client'];
export function isLogoDisplayed () {
    const clientId = getClientById() || '';
    return !noLogoClients.includes(clientId);
}
